module.exports = __webpack_public_path__ + "static/media/page_25.77cc19b8.jpg";